import { Table } from "../../../components/table-components/Table";
import { TableCellHeaderText } from "../../../components/table-components/TableCellHeaderText";
import { TableRowHeader } from "../../../components/table-components/TableRowHeader";
import { SpinnerBlock } from "../../common/Spinner";
import OrderListRow from "../../shop/orders/order-list/OrderListRow";
import { CardHeader } from "../../../components/CardHeader";
import { useSelector } from "react-redux";
import * as authSelectors from "../../auth/authSelectors";
import { StatusBadge } from "../../../components/StatusBadge";
import { colors } from "../../../components/colors";
import { OrderByFilter } from "../../shop/model/GetOrderListOrderBy";
import { GetOrderListFilters } from "../../shop/model/GetOrderListFilters";
import { useHandleFetchError } from "../../../error-handler";
import { useListOrders } from "../../shop/orders/service/order-api";
import { ORDER_FILTER_STATES } from "../../../util";

export const DashboardOrdersSection = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  const orderByFilter: OrderByFilter = {
    orderBy: "createdAt",
    sortDir: "desc",
  };

  const listFilters: GetOrderListFilters = {
    filterByStates: ORDER_FILTER_STATES,
  };

  const {
    data: orders,
    isLoading: ordersAreLoading,
    error: getOrdersError,
  } = useListOrders(organizationKeyName, listFilters, orderByFilter, 10);

  useHandleFetchError(getOrdersError);

  return (
    <div className="card">
      <CardHeader title="Orders" subtitle={`View the last 10 orders placed`}>
        <div
          className="d-flex flex-row align-items-center"
          style={{ gap: "16px" }}
        >
          <StatusBadge size="large" statusColor={colors.successMedium}>
            Live
          </StatusBadge>
        </div>
      </CardHeader>
      <div
        className="card-body d-flex flex-column pb-0"
        style={{ gap: "16px" }}
      >
        {ordersAreLoading ? (
          <SpinnerBlock />
        ) : (
          <Table>
            <thead>
              <TableRowHeader>
                <TableCellHeaderText className="pl-3">ID</TableCellHeaderText>
                <TableCellHeaderText>Customer</TableCellHeaderText>
                <TableCellHeaderText>Restaurant</TableCellHeaderText>
                <TableCellHeaderText style={{ whiteSpace: "nowrap" }}>
                  Order type
                </TableCellHeaderText>
                <TableCellHeaderText style={{ whiteSpace: "nowrap" }}>
                  Time of order
                </TableCellHeaderText>
                <TableCellHeaderText style={{ whiteSpace: "nowrap" }}>
                  Time ordered for
                </TableCellHeaderText>
                <TableCellHeaderText style={{ whiteSpace: "nowrap" }}>
                  Order status
                </TableCellHeaderText>
                <TableCellHeaderText style={{ whiteSpace: "nowrap" }}>
                  Total price
                </TableCellHeaderText>
              </TableRowHeader>
            </thead>
            <tbody>
              {orders?.map((order) => {
                return <OrderListRow key={order.id} order={order} />;
              })}
            </tbody>
          </Table>
        )}
      </div>
      <div className="card-footer text-center mr-5 ml-5 px-0" />
    </div>
  );
};
